<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Bląd raportowania
                </h1>
            </v-card-title>

            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12" lg="6">
                            <v-text-field
                                v-model="jobNumber"
                                label="Numer zlecenia"
                                :error-messages="jobNumberErrors()"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-text-field
                                v-model="impositionNumber"
                                label="numer montazu"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    @click="onSubmit"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { minLength } from 'vuelidate/lib/validators'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'ErrorReportingDialog',
    props: {
        isOpen: {
            type: Boolean,
        }
    },
    data() {
        return {
            jobNumber: '',
            impositionNumber: ''
        }
    },
    validations() {
        return {
            jobNumber: {
                required,
                minLength: minLength(3)
            }
        }
    },
    methods: {
        jobNumberErrors() {
            const errors = []

            if (!this.$v.jobNumber.$dirty) return errors
            if (!this.$v.jobNumber.required)
                errors.push('Numer zlecenia jest wymagany')
            if (!this.$v.jobNumber.minValue) {
                errors.push('Numer zlecenia musi mieć co najmniej 3 znaki')
            }

            return errors
        },
        onSubmit() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                return
            }

            this.$emit('on-submit', {
                jobNumber: this.jobNumber,
                impositionNumber: this.impositionNumber
            })
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.jobNumber = ''
                this.impositionNumber = ''
            }, 500)
            this.$v.$reset()

            this.$emit('on-close')
        }
    }
}
</script>
